export const ACTION_ROTATION = {
  GET_DATA_ROTATION: "GET_DATA_ROTATION",
  GET_DATA_ROTATION_SUCCESS: Symbol("GET_DATA_ROTATION_SUCCESS"),
  GET_DATA_ROTATION_FAILED: Symbol("GET_DATA_ROTATION_FAILED"),
  START_WHEEL: "START_WHEEL",
  START_WHEEL_SUCCESS: Symbol("START_WHEEL_SUCCESS"),
  START_WHEEL_FAILED: Symbol("START_WHEEL_FAILED"),
  CLOSE_NOTIFY: Symbol("CLOSE_NOTIFY")
};
